export const noop = () => undefined;
export const identity = (value) => value;
